var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"wrapper"},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_vm._m(0),_c('TosBox',{staticClass:"web-tos"})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('div',[_vm._v("Copyright © 2023- Chicchat Social Media Pte. Ltd.")])])
}]

export { render, staticRenderFns }